import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crosshair, ChevronRight } from "lucide-react";

/** Persistent resume prompt for users who skipped the guided onboarding. */
const ActivationResumeCard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user || user.role === "admin") return null;
  if (user.activation?.completed) return null;

  return (
    <button
      data-testid="activation-resume-card"
      onClick={() => navigate("/welcome")}
      className="w-full text-left glass rounded-2xl p-5 border border-warning/30 bg-warning/5 hover:border-warning/60 transition-all hover-lift flex items-center gap-4"
    >
      <div className="w-10 h-10 rounded-xl bg-warning/15 flex items-center justify-center flex-shrink-0">
        <Crosshair className="w-5 h-5 text-warning" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold">Complete your readiness setup</p>
        <p className="text-sm text-muted-foreground">Find your weakest subject and get a recommended study plan - takes 3 minutes.</p>
      </div>
      <ChevronRight className="w-5 h-5 text-warning flex-shrink-0" />
    </button>
  );
};

export default ActivationResumeCard;
